import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Emit } from "vue-facing-decorator";
let WSlider = class WSlider extends Vue {
  constructor(...args) {
    super(...args);
    /**
     * Represents a variable that can hold either a single numeric value
     * or an array of numeric values.
     *
     * The value can be:
     * - A single number, representing a numeric value.
     * - An array of numbers, representing a range.
     */
    _defineProperty(this, "modelValue", void 0);
    /**
     * Minimum value.
     */
    _defineProperty(this, "min", void 0);
    /**
     * Maximum value.
     */
    _defineProperty(this, "max", void 0);
    /**
     * Represents the step value for incremental changes.
     */
    _defineProperty(this, "step", void 0);
    /**
     * Indicates whether the slider is disabled.
     */
    _defineProperty(this, "disabled", void 0);
    /**
     * Whether to display an input box, works when range is false.
     */
    _defineProperty(this, "showInput", void 0);
    /**
     * Whether to display control buttons when show-input is true.
     */
    _defineProperty(this, "showInputControls", void 0);
    /**
     * A boolean flag that determines whether to display stops or markers
     * along a given range or track in the user interface.
     */
    _defineProperty(this, "showStops", void 0);
    /**
     * Indicates whether a tooltip should be displayed when selecting a value.
     */
    _defineProperty(this, "showTooltip", void 0);
    /**
     * Specifies whether the range is enabled or not.
     */
    _defineProperty(this, "range", void 0);
    /**
     * vertical mode.
     */
    _defineProperty(this, "vertical", void 0);
    /**
     * slider height, required in vertical mode.
     */
    _defineProperty(this, "height", void 0);
    /**
     * An optional label that provides a descriptive name or title.
     */
    _defineProperty(this, "label", void 0);
    /**
     * debounce delay when typing, in milliseconds, works when show-input is true
     */
    _defineProperty(this, "debounce", void 0);
    /**
     * custom class name for the tooltip
     */
    _defineProperty(this, "tooltipClass", void 0);
    /**
     * Represents the marks associated with a given item or entity.
     * The type of key must be number and must be in closed interval [min, max]
     */
    _defineProperty(this, "marks", void 0);
  }
  get innerValue() {
    return this.modelValue;
  }
  set innerValue(val) {
    this.updateValue(val);
  }
  updateValue(val) {
    return val;
  }
  handleChange(val) {
    return val;
  }
  handleInput(val) {
    return val;
  }
};
__decorate([Prop({
  required: true
})], WSlider.prototype, "modelValue", void 0);
__decorate([Prop({
  default: 0
})], WSlider.prototype, "min", void 0);
__decorate([Prop({
  default: 100
})], WSlider.prototype, "max", void 0);
__decorate([Prop({
  default: 1
})], WSlider.prototype, "step", void 0);
__decorate([Prop({
  default: false
})], WSlider.prototype, "disabled", void 0);
__decorate([Prop({
  default: false
})], WSlider.prototype, "showInput", void 0);
__decorate([Prop({
  default: true
})], WSlider.prototype, "showInputControls", void 0);
__decorate([Prop({
  default: false
})], WSlider.prototype, "showStops", void 0);
__decorate([Prop({
  default: true
})], WSlider.prototype, "showTooltip", void 0);
__decorate([Prop({
  default: false
})], WSlider.prototype, "range", void 0);
__decorate([Prop({
  default: false
})], WSlider.prototype, "vertical", void 0);
__decorate([Prop()], WSlider.prototype, "height", void 0);
__decorate([Prop()], WSlider.prototype, "label", void 0);
__decorate([Prop({
  default: 300
})], WSlider.prototype, "debounce", void 0);
__decorate([Prop()], WSlider.prototype, "tooltipClass", void 0);
__decorate([Prop()], WSlider.prototype, "marks", void 0);
__decorate([Emit('update:modelValue')], WSlider.prototype, "updateValue", null);
__decorate([Emit('change')], WSlider.prototype, "handleChange", null);
__decorate([Emit('input')], WSlider.prototype, "handleInput", null);
WSlider = __decorate([Component({})], WSlider);
export default WSlider;